import React, { useState, useEffect } from "react";
import api from "../services/api";
import { Link } from "react-router-dom";
import Slider from "react-slick";

export default function LoyaltyProgram(props) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  return (
    <>
      <div className="container-xxl">
        <div className="loyaltyProgram">
          <div className="VIP-banners">
            <div className="banner-text-area">
              <h1 className="heading-text">chilirojo's VIP Levels</h1>
              <p className="banner-text">
                Explore our VIP levels and discover amazing perks, from exciting
                gifts to bonus rewards with each purchase. The higher you climb,
                the more you get!
              </p>
            </div>
            <img
              alt=""
              className="banner-img"
              src={require("assets/chilirojo/images/loyaltyProgram/main-chilirojo-banner.png")}
            />
            <div className="vip-levels-slider">
              <Slider {...settings}>
                <div className="single-slider copper">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/copper-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Copper</Link>
                  </div>
                </div>
                <div className="single-slider bronze">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/bronze-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Bronze</Link>
                  </div>
                </div>
                <div className="single-slider silver">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/silver-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Silver</Link>
                  </div>
                </div>
                <div className="single-slider gold">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/gold-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Gold</Link>
                  </div>
                </div>
                <div className="single-slider opal">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/opal-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Opal</Link>
                  </div>
                </div>
                <div className="single-slider sapphire">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/sapphire-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Sapphire</Link>
                  </div>
                </div>
                <div className="single-slider emerald ">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/emerald-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Emerald</Link>
                  </div>
                </div>
                <div className="single-slider ruby ">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/ruby-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Ruby</Link>
                  </div>
                </div>
                <div className="single-slider diamond ">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/diamond-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Diamond</Link>
                  </div>
                </div>
                <div className="single-slider black-diamond ">
                  <div className="vip-madel">
                    <img
                      alt=""
                      className="madel-img"
                      src={require("assets/chilirojo/images/vip-madels/black-diamond-madel.png")}
                    />
                  </div>
                  <div className="madel-items">
                    <ul>
                      <li>I</li>
                      <li>II</li>
                      <li>III</li>
                      <li>IV</li>
                    </ul>
                  </div>
                  <div className="vip-items">
                    <ul>
                      <li>
                        <label>Gold Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Weekly Sweep Coins Free Spins</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Sweep Coins One Time Bonus</label>
                        <span>Value</span>
                      </li>
                      <li>
                        <label>Bonus Sweep Coins Per Buy</label>
                        <span>Value</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bottom-action">
                    <Link className="commonBtn pOneBtn">Black Diamond</Link>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
      </div>
      <br />
      <br />

      <br />
      <br />
    </>
  );
}
